var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSh2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_816_78709)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3265 7.93649C20.9514 7.55145 20.3962 7.408 19.8784 7.559L7.806 11.0696C7.25977 11.2214 6.87262 11.657 6.76832 12.2104C6.66178 12.7736 7.03393 13.4886 7.52013 13.7876L11.2949 16.1076C11.6821 16.3454 12.1818 16.2858 12.5022 15.9627L16.8247 11.6132C17.0423 11.3867 17.4024 11.3867 17.62 11.6132C17.8376 11.8322 17.8376 12.187 17.62 12.4135L13.29 16.7637C12.9689 17.0861 12.9088 17.5881 13.1452 17.9777L15.4516 21.7903C15.7217 22.2433 16.1869 22.5 16.6971 22.5C16.7572 22.5 16.8247 22.5 16.8847 22.4924C17.47 22.417 17.9351 22.0168 18.1077 21.4506L21.6867 9.39359C21.8442 8.88021 21.7017 8.32153 21.3265 7.93649",
    fill: "url(#paint1_linear_816_78709)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_78709",
    x1: 0,
    y1: 0,
    x2: 30.599,
    y2: 0.813926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_816_78709",
    x1: 6.75,
    y1: 7.5,
    x2: 22.0495,
    y2: 7.90696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91E5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh2);
export default __webpack_public_path__ + "static/media/sh2.0d6b74eb0697e3d457c3f2f2ab729871.svg";
export { ForwardRef as ReactComponent };